module.exports = __webpack_public_path__ + "static/bullet-background-8c070532c6645cd04d311d8a743e2452.png";